import { create } from 'zustand';


export type TagQuery =
  | { mode: 'current' }
  | { mode: 'asOf'; asOf: string }
  | { mode: 'range'; from: string; to?: string };

export interface TagDataStore {
  query: TagQuery;
  showAllReads: boolean;
  setQuery: (query: TagQuery) => void;
  toggleShowAllReads: () => void;
  reset: () => void;
}

const initialTagDataState = {
  query: { mode: 'current' },
  showAllReads: true,
} satisfies Pick<TagDataStore, 'query' | 'showAllReads'>;

export const useTagDataStore = create<TagDataStore>((set, get) => ({
  ...initialTagDataState,
  setQuery: (query) => set({ query }),
  toggleShowAllReads: () => set({ showAllReads: !get().showAllReads }),
  reset: () => set(initialTagDataState),
}));
